<script lang="ts">
	export let fill = '#4B25BB';
	export let size = 15;
</script>

<svg
	class="animate-spin"
	xmlns="http://www.w3.org/2000/svg"
	width={size}
	height={size}
	viewBox="0 0 15 15"
	fill="none"
>
	<path
		d="M15 7.5C15 6.01664 14.5601 4.56659 13.736 3.33322C12.9119 2.09985 11.7406 1.13856 10.3701 0.570903C8.99968 0.00324625 7.49168 -0.145279 6.03682 0.14411C4.58196 0.4335 3.24559 1.14781 2.1967 2.1967C1.14781 3.24559 0.4335 4.58196 0.14411 6.03682C-0.145279 7.49168 0.00324627 8.99968 0.570904 10.3701C1.13856 11.7406 2.09985 12.9119 3.33322 13.736C4.56659 14.5601 6.01664 15 7.5 15V12.1392C6.58245 12.1392 5.68551 11.8671 4.9226 11.3573C4.15969 10.8476 3.56507 10.123 3.21394 9.27534C2.86281 8.42764 2.77094 7.49485 2.94995 6.59494C3.12895 5.69502 3.57079 4.8684 4.21959 4.21959C4.8684 3.57079 5.69502 3.12895 6.59494 2.94995C7.49485 2.77094 8.42764 2.86281 9.27534 3.21394C10.123 3.56507 10.8476 4.15969 11.3573 4.9226C11.8671 5.68551 12.1392 6.58245 12.1392 7.5H15Z"
		{fill}
		style={`fill: ${fill}`}
	/>
</svg>
